function getHomepageArticles(static_content) {
    return static_content.helpful_information.articles.filter((el) => el.featured)
}

function getFaqs(static_content) {
    return static_content.helpful_information.faq.filter((el) => el.featured)
}

module.exports = {
    getHomepageArticles,
    getFaqs
}